"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */ //TODO: need to remove this and figure out the props
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
exports.default = (function (src, skipMountingScript) {
    var _a = react_1.default.useState({
        loaded: false,
        error: false
    }), state = _a[0], setState = _a[1];
    react_1.useEffect(function () {
        if (!document)
            return undefined;
        if (skipMountingScript) {
            setState({
                loaded: true,
                error: false
            });
            return undefined;
        }
        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        var onScriptLoad = function () {
            setState({
                loaded: true,
                error: false
            });
        };
        var onScriptError = function () {
            script.remove();
            setState({
                loaded: true,
                error: true
            });
        };
        script.addEventListener('load', onScriptLoad);
        script.addEventListener('error', onScriptError);
        document.body.appendChild(script);
        return function () {
            script.removeEventListener('load', onScriptLoad);
            script.removeEventListener('error', onScriptError);
        };
    }, [src, skipMountingScript]);
    return [state.loaded, state.error];
});
//# sourceMappingURL=useScript.js.map